import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosClient from '@/services/axios';
import { getUser } from './auth-thunk';

export const getOtp = createAsyncThunk(
  'profile/update-contact',
  async ({ body }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        `/api/profile/update-contact/otp`,
        {
          ...body,
        },
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const verifyOtp = createAsyncThunk(
  'profile/verify-contact',
  async ({ otp }, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        `/api/profile/update-contact/otp/verify/${getState().myProfile.OTPInfo?.referenceId}`,
        {
          otp,
        },
      );
      setTimeout(() => dispatch(getUser()), 500);
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const resendOtp = createAsyncThunk(
  'auth/otp/resend',
  async ({ extendExpiry = 300 }, { getState, rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        `/api/auth/otp/resend?${getState().myProfile.OTPInfo?.referenceId}`,
        {
          extendExpiry,
          referenceId: getState().myProfile.OTPInfo?.referenceId,
        },
      );
      return response.data;
    } catch (e) {
      return rejectWithValue(e.response?.data || e.message);
    }
  },
);
